import { isCognitoConfigured, readSession } from "./cognito";
import { getWorkspace } from "./workspace";

export const CUSTOMER_STORAGE_KEY = "ardley-crm.customer-id";

export type StubCustomerId = "100004" | "100081";

export function getStubCustomerId(): StubCustomerId {
  if (typeof window === "undefined") return "100004";
  const stored = window.localStorage.getItem(CUSTOMER_STORAGE_KEY);
  if (stored === "100081" || stored === "100004") return stored;
  return "100004";
}

export function setStubCustomerId(id: StubCustomerId) {
  window.localStorage.setItem(CUSTOMER_STORAGE_KEY, id);
}

export const ROLE_STORAGE_KEY = "ardley-crm.role";

/** Roles the dev stub login offers; the local BFF maps them like the token's custom:role. */
export const STUB_ROLES = ["admin", "loan-officer", "read-only"] as const;

export type StubRole = (typeof STUB_ROLES)[number];

export function getStubRole(): StubRole {
  if (typeof window === "undefined") return "admin";
  const stored = window.localStorage.getItem(ROLE_STORAGE_KEY);
  return STUB_ROLES.find((role) => role === stored) ?? "admin";
}

export function setStubRole(role: StubRole) {
  window.localStorage.setItem(ROLE_STORAGE_KEY, role);
}

/**
 * Who the cached data belongs to: user + tenant. A persisted cache written
 * under a different owner is discarded instead of shown.
 */
export function principalCacheKey(): string {
  if (!isCognitoConfigured()) {
    return `stub:${getStubCustomerId()}:${getStubRole()}:${getWorkspace()}`;
  }
  const session = readSession();
  // The workspace too: a persisted cache from recruiting must never show in
  // originations (0025).
  return session
    ? `${session.sub}:${session.customerId}:${getWorkspace()}`
    : "anonymous";
}
